
import common from '../../utils/common';
import InputRegion from '~/components/inputRegion';
import { debounce } from '@/utils/debounce';
import * as Cookies from 'js-cookie';
export default {
  components: { InputRegion },
  auth: 'guest',
  mixins: [common],
  data() {
    return {
      phoneValidated: false,
      phoneValidText: undefined,
      activeFinder: false,
      container: {},
      step: 1,
      form: {
        nickname: '',
        birth: '',
        phone: '',
        gender: '남',
        referrer: '',
        district_id: '',
        is_agree_push: false,
        is_agree_privacy: true,
      },
      agreements: [],
      agree1: false,
      agree2: false,
      agree3: false,
      agree4: false,
      agree5: false,
      agree6: false,

      errors: {},
      isClient: false,
    };
  },

  computed: {
    isAgreeAll() {
      return (
        this.agree1 &&
        this.agree2 &&
        // this.agree3 &&
        this.agree4 &&
        this.agree6 &&
        this.form.is_agree_push
      );
    },
    agreement1() {
      return this.agreements.length > 0
        ? this.agreements.find(
            (agreement) => agreement.category === 'agreement1',
          )
        : '';
    },
    agreement2() {
      return this.agreements.length > 0
        ? this.agreements.find(
            (agreement) => agreement.category === 'agreement2',
          )
        : '';
    },
    agreement4() {
      return this.agreements.length > 0
        ? this.agreements.find(
            (agreement) => agreement.category === 'agreement4',
          )
        : '';
    },

    computedPhoneValid() {
      return this.phoneValidated ? 'primary' : '';
    },
  },
  watch: {
    'form.phone': {
      handler: function (val, oldVal) {
        if (this.validatePhone(val) || val === '') {
          if (val == '') this.phoneValidText = '';
          if (this.validatePhone(val)) this.getPhoneValidation(val);
        } else {
          this.phoneValidText = '11자리 휴대폰 번호를 입력해주세요.';
          this.phoneValidated = false;
        }
      },
    },
    agree4: {
      handler: function (val) {
        if (val) {
          this.form.is_agree_push = true;
        } else {
          this.form.is_agree_push = false;
        }
      },
    },
  },
  methods: {
    async getPhoneValidation(phone) {
      const { result, message } = await this.$axios.$get(
        `/api/member-certify?phone=${phone}`,
      );
      this.phoneValidated = result;
      // result == true ?  this.phoneValidated = true : this.phoneValidated = false;
      this.phoneValidText = message ?? '';
      // message ? this.phoneValidText = message : this.phoneValidText = ''
    },
    async getAggrements() {
      const agreements = await this.$axios.$get('/data/agreements.json');
      this.agreements = agreements;
    },
    openFinder() {
      this.activeFinder = true;
    },
    closeFinder() {
      this.activeFinder = false;
    },
    setContainer(container) {
      this.container = container;
    },
    changeDistrict(data) {
      // this.form.district = data.district
      this.form.district_id = data.district_id;
    },
    isUnderFourteen(birthDateStr) {
      // 현재 날짜
      const today = new Date();
      const currentYear = today.getFullYear();
      const currentMonth = today.getMonth() + 1; // JavaScript의 월은 0부터 시작하므로 1을 더해줍니다.
      const currentDay = today.getDate();

      // 생년월일에서 년, 월, 일 추출
      const birthYear = parseInt(birthDateStr.substring(0, 4), 10);
      const birthMonth = parseInt(birthDateStr.substring(4, 6), 10);
      const birthDay = parseInt(birthDateStr.substring(6, 8), 10);

      // 나이 계산
      let age = currentYear - birthYear;

      // 현재 월과 일을 고려하여 나이를 조정
      if (
        birthMonth > currentMonth ||
        (birthMonth === currentMonth && birthDay > currentDay)
      ) {
        age--;
      }

      // 나이가 14세 미만인지 확인
      return age < 14;
    },
    login() {
      this.$auth
        // .loginWith('laravelSanctum', { data: this.form })
        .loginWith('local', {
          data: {
            username: this.form.phone,
            password: this.form.birth,
          },
        }) // 'laravelSanctum' → JWT 전략명('local' 혹은 설정한 이름)
        .then((response) => {
          if (process.client) {
            if (window.loginChannel) {
              // response.data 구조가 JWT에서는 토큰 + user 정보가 담기므로 적절히 수정
              window.loginChannel.postMessage(
                JSON.stringify({ success: response }),
              );
            }
          }
          Cookies.set('auth_token', response.data.token, {
            expires: 365, // 7일 동안 쿠키 유지
            sameSite: 'strict', // CSRF 공격 방지
            // secure: process.env.NODE_ENV === 'production', // HTTPS 환경에서만 전송
          });
          // const cookie = useCookie('auth_token', {
          //   maxAge: 60 * 60 * 24 * 7,
          //   sameSite: true,
          //   secure: process.env.NODE_ENV === 'production', // 개발에서는 false : safari, firefox에서 쿠키가 생성안되는 현상 방지
          // });
          // cookie = token;
          this.$auth.setUser(response.data.user);
          this.$store.commit('setUserToken', response.data.token);
          // this.$auth.user 객체가 JWT 로그인 후에 현재 로그인 사용자 정보 담음
          // 예: this.$auth.user?.district 가 백엔드에서 보내주는 사용자 정보 내 필드명과 일치해야 함
          this.$store.commit('changeDistrict', this.$auth.user?.district);

          this.$router.push(
            this.$auth.$state.redirect ? this.$auth.$state.redirect : '/',
          );
          this.$router.push('/auth/success');
        })
        .catch((e) => {
          console.log(e, 3333);
          if (e.response.data.errors) this.errors = e.response.data.errors;
        });
    },
    register() {
      if (!this.validatePhone(this.form.phone))
        return alert(
          '010으로 시작하는 11자리 핸드폰번호를 입력하주세요. 예: 01012345678',
        );
      if (this.phoneValidText.includes('탈퇴'))
        return alert(this.phoneValidText);
      if (!this.validateDate(this.form.birth))
        return alert('생년월일 8자리를 올바르게 입력해주세요. 예: 19660510');
      if (this.isUnderFourteen(this.form.birth))
        return alert('만 14세 미만은 가입할 수 없습니다.');
      if (this.form.referrer && !this.validatePhone(this.form.referrer))
        return alert(
          '추천인 전화 번호를 올바르게 입력해주세요. 예: 01012345678',
        );
      if (this.form.phone == this.form.referrer)
        return alert('본인을 추천인으로 등록할 수 없습니다.');
      this.form = {
        ...this.form,
        name: this.form.nickname,
        username: this.form.phone,
        password: this.form.birth,
        password_confirmation: this.form.birth,
      };
      console.log({ ...this.form }, 565656);
      this.$axios
        .post('/api/auth/register', this.form)
        .then((response) => {
          this.login();
          // this.login(
          //   {
          //     phone: this.form.phone,
          //     password: this.form.birth,
          //   },
          //   () => {
          //     this.$router.push('/auth/success');

          //     this.$store.commit('changeDistrict', this.$auth.user?.district);
          //   }
          // );
        })
        .catch((error) => {
          if (error.response && error.response.data)
            this.errors = error.response.data.errors;
          if (error.response.status === 422) alert(error.response.data.message);
        });
    },
    // helpRegister() {
    //     if(!this.validatePhone(this.form.phone))
    //         return alert('휴대폰번호를 올바르게 입력해주세요. 예: 01012345678')
    //     if(!this.validateDate(this.form.birth))
    //         return alert('생년월일을 올바르게 입력해주세요.')
    //     if(!this.form.is_agree_privacy)
    //         return alert("필수약관에 동의해주세요.");
    //     if(this.form.referrer && !this.validatePhone(this.form.referrer))
    //         return alert('추천인번호는 11자리로 입력해주세요. 예: 01012345678')
    //     if(this.form.phone == this.form.referrer)
    //         return alert('본인을 추천인으로 등록할 수 없습니다.');
    //     this.$axios.post("/api/auth/register", this.form)
    //         .then((response) => {
    //             alert('가입신청 완료되었습니다.')
    //             this.$router.push("/");
    //         })
    //         .catch(e => {
    //             if(e.response && e.response.data)
    //                 this.errors = e.response.data.errors;
    //             if(error.response.status === 422)
    //                 alert(error.response.data.message)
    //         });
    // },

    agreeAll() {
      this.agree1 = true;
      this.agree2 = true;
      // this.agree3 = true;
      this.agree4 = true;
      // this.agree5 = true;
      this.agree6 = true;
      this.form.is_agree_push = true;
    },

    next() {
      if (this.step === 1) {
        if (
          !this.agree1 ||
          !this.agree2 ||
          // !this.agree3 ||
          // !this.agree4 ||
          !this.agree6
        )
          return alert('필수약관에 동의해주세요.');
      }

      this.step += 1;
    },

    // login(data, callback) {
    //   this.$auth
    //     .loginWith('laravelSanctum', { data: data })
    //     .then((response) => {
    //       callback();
    //     })
    //     .catch((e) => {});
    // },

    replaceBr(str) {
      if (!str) return '';
      const os = require('os');
      return str.replace(/<br\s*\/?>/g, os.EOL);
    },

    async middleMethod(message) {
      this.fromFlutter = JSON.stringify(message);

      if (typeof message == 'object') {
        await this.loginFlutter(message);
      }
    },
  },

  async mounted() {
    await this.getAggrements();
    window.loginFromFlutter = (message) => {
      this.middleMethod(message);
    };
    if (process.client) {
      this.isClient = true;
    }
    if (window.loginChannel) {
      this.channel = true;
    }
  },
  created() {
    this.debounceRegister = debounce((item) => {
      this.register(item);
    }, 500);
  },
};
